import { render } from "./swiper.vue?vue&type=template&id=48a69ea9"
import script from "./swiper.vue?vue&type=script&lang=ts"
export * from "./swiper.vue?vue&type=script&lang=ts"

import "./swiper.vue?vue&type=style&index=0&id=48a69ea9&lang=scss"
script.render = render

export default script